import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Count_records extends PureComponent {
  render() {
    return (
      <div className="row" id="search_records">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Count Records</h2>
              <p>
                The API search function is limited to 10,000 records without
                enabling a database scroll. The API count records function is an
                unlimited method for counting the number of records of an object
                type.
              </p>
              <p>
                The API count records function supports queries as seen in
                example 2.
              </p>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Count Records Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Count</h3>
              <p>This example is a simple count with no queries or filters.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/count
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>
                The response shows that the search request took 3 milliseconds
                and says there are 25 records.
              </p>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">3</span>,
                </div>

                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">25</span>
                </div>

                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Simple query</h3>
              <p>
                This example filters all records where text_status equals
                “open”.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/count
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"query"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"term"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_status"</span>:{" "}
                  <span className="jsonY">"open"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Count_records;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Count_records.js